/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BreakdownResponse } from '../models';
// @ts-ignore
import type { CardMixResponse } from '../models';
// @ts-ignore
import type { CheckoutFunnelResponse } from '../models';
// @ts-ignore
import type { DashboardSummaryResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { MetricSeriesResponse } from '../models';
// @ts-ignore
import type { TopMerchantsResponse } from '../models';
/**
 * PartnerDashboardApi - axios parameter creator
 * @export
 */
export const PartnerDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns checkout funnel analytics showing session drop-off and completion metrics.
         * @summary Get checkout funnel analytics for a partner
         * @param {string} partnerId Partner identifier (ULID)
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by. If omitted, includes all partner merchants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutFunnel: async (partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getCheckoutFunnel', 'partnerId', partnerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getCheckoutFunnel', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getCheckoutFunnel', 'toDate', toDate)
            const localVarPath = `/api/v1/partners/{partnerId}/dashboard/checkout-funnel`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Groups the partner\'s ledger rows in range by the chosen `dimension` and returns per-group `count`, `volume` (cents), and `sharePercentage` (count-share of total). Used by the Admin UI partner analytics view to render the \"transaction mix\" breakdowns that aren\'t covered by card-mix.  - `transaction-type`: groups by `transaction_type` (PAYMENT / REFUND / VOID / CHARGEBACK) - `payment-method`: groups by `payment_method_type`  Both dimensions count **all ledger rows in range** (not PAYMENT-only) for parity between the two cuts — per FF-2670\'s recommendation. UI filters client-side if it needs a PAYMENT-only view.  `sharePercentage` is **count-share** (group_count / total_count × 100). The `volume` field is returned alongside so the UI can switch to volume-share client-side without a second call.  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list, zero `totalCount`, and zero `totalVolume`. 
         * @summary Transaction breakdown by transaction-type or payment-method
         * @param {string} partnerId Partner identifier
         * @param {GetDashboardBreakdownDimensionEnum} dimension Which dimension to group by. Blank or unknown value returns 400 &#x60;INVALID_DIMENSION&#x60;. 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardBreakdown: async (partnerId: string, dimension: GetDashboardBreakdownDimensionEnum, fromDate: string, toDate: string, merchantIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getDashboardBreakdown', 'partnerId', partnerId)
            // verify required parameter 'dimension' is not null or undefined
            assertParamExists('getDashboardBreakdown', 'dimension', dimension)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getDashboardBreakdown', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getDashboardBreakdown', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/dashboard/breakdown`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dimension !== undefined) {
                localVarQueryParameter['dimension'] = dimension;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) with sales volume, fee volume, and percentage shares for each category. 
         * @summary Get card mix breakdown by card category
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCardMix: async (partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getDashboardCardMix', 'partnerId', partnerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getDashboardCardMix', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getDashboardCardMix', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/dashboard/card-mix`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns time series data for any dashboard metric, suitable for charting. Interval auto-selected by date range span (daily/weekly/monthly). 
         * @summary Get time series data for a specific dashboard metric
         * @param {string} partnerId Partner identifier
         * @param {GetDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardMetricSeries: async (partnerId: string, metric: GetDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, merchantIds?: string, intervals?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getDashboardMetricSeries', 'partnerId', partnerId)
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getDashboardMetricSeries', 'metric', metric)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getDashboardMetricSeries', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getDashboardMetricSeries', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/dashboard/metric-series`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metric !== undefined) {
                localVarQueryParameter['metric'] = metric;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }

            if (intervals !== undefined) {
                localVarQueryParameter['intervals'] = intervals;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregated financial metrics for a partner over a date range.
         * @summary Get aggregated dashboard summary metrics for a partner
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardSummary: async (partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getDashboardSummary', 'partnerId', partnerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getDashboardSummary', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getDashboardSummary', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/dashboard/summary`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ranks a partner\'s merchants by PAYMENT-type `total_amount` descending over the requested date range, limited to `limit` rows. Each row carries `merchantId`, `merchantName` (null-safe), `transactionCount`, and `salesVolume` (cents). The response envelope also carries the partner-wide `totalSalesVolume` and `currency` so the UI can show \"top N of total\".  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints. Merchant principals are rejected; cross-partner returns 403.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list and a zero `totalSalesVolume`. 
         * @summary Top merchants for a partner ranked by sales volume
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
         * @param {number} [limit] Maximum rows to return. Default 10; clamped to [1, 50]. Values outside the range return 400 &#x60;INVALID_LIMIT_PARAM&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardTopMerchants: async (partnerId: string, fromDate: string, toDate: string, merchantIds?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getDashboardTopMerchants', 'partnerId', partnerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getDashboardTopMerchants', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getDashboardTopMerchants', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/dashboard/top-merchants`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerDashboardApi - functional programming interface
 * @export
 */
export const PartnerDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns checkout funnel analytics showing session drop-off and completion metrics.
         * @summary Get checkout funnel analytics for a partner
         * @param {string} partnerId Partner identifier (ULID)
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by. If omitted, includes all partner merchants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckoutFunnel(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutFunnelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckoutFunnel(partnerId, fromDate, toDate, merchantIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerDashboardApi.getCheckoutFunnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Groups the partner\'s ledger rows in range by the chosen `dimension` and returns per-group `count`, `volume` (cents), and `sharePercentage` (count-share of total). Used by the Admin UI partner analytics view to render the \"transaction mix\" breakdowns that aren\'t covered by card-mix.  - `transaction-type`: groups by `transaction_type` (PAYMENT / REFUND / VOID / CHARGEBACK) - `payment-method`: groups by `payment_method_type`  Both dimensions count **all ledger rows in range** (not PAYMENT-only) for parity between the two cuts — per FF-2670\'s recommendation. UI filters client-side if it needs a PAYMENT-only view.  `sharePercentage` is **count-share** (group_count / total_count × 100). The `volume` field is returned alongside so the UI can switch to volume-share client-side without a second call.  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list, zero `totalCount`, and zero `totalVolume`. 
         * @summary Transaction breakdown by transaction-type or payment-method
         * @param {string} partnerId Partner identifier
         * @param {GetDashboardBreakdownDimensionEnum} dimension Which dimension to group by. Blank or unknown value returns 400 &#x60;INVALID_DIMENSION&#x60;. 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardBreakdown(partnerId: string, dimension: GetDashboardBreakdownDimensionEnum, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardBreakdown(partnerId, dimension, fromDate, toDate, merchantIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerDashboardApi.getDashboardBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) with sales volume, fee volume, and percentage shares for each category. 
         * @summary Get card mix breakdown by card category
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardCardMix(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardMixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardCardMix(partnerId, fromDate, toDate, merchantIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerDashboardApi.getDashboardCardMix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns time series data for any dashboard metric, suitable for charting. Interval auto-selected by date range span (daily/weekly/monthly). 
         * @summary Get time series data for a specific dashboard metric
         * @param {string} partnerId Partner identifier
         * @param {GetDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardMetricSeries(partnerId: string, metric: GetDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, merchantIds?: string, intervals?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricSeriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardMetricSeries(partnerId, metric, fromDate, toDate, merchantIds, intervals, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerDashboardApi.getDashboardMetricSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns aggregated financial metrics for a partner over a date range.
         * @summary Get aggregated dashboard summary metrics for a partner
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardSummary(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardSummary(partnerId, fromDate, toDate, merchantIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerDashboardApi.getDashboardSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ranks a partner\'s merchants by PAYMENT-type `total_amount` descending over the requested date range, limited to `limit` rows. Each row carries `merchantId`, `merchantName` (null-safe), `transactionCount`, and `salesVolume` (cents). The response envelope also carries the partner-wide `totalSalesVolume` and `currency` so the UI can show \"top N of total\".  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints. Merchant principals are rejected; cross-partner returns 403.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list and a zero `totalSalesVolume`. 
         * @summary Top merchants for a partner ranked by sales volume
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
         * @param {number} [limit] Maximum rows to return. Default 10; clamped to [1, 50]. Values outside the range return 400 &#x60;INVALID_LIMIT_PARAM&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardTopMerchants(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopMerchantsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardTopMerchants(partnerId, fromDate, toDate, merchantIds, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerDashboardApi.getDashboardTopMerchants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerDashboardApi - factory interface
 * @export
 */
export const PartnerDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerDashboardApiFp(configuration)
    return {
        /**
         * Returns checkout funnel analytics showing session drop-off and completion metrics.
         * @summary Get checkout funnel analytics for a partner
         * @param {string} partnerId Partner identifier (ULID)
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by. If omitted, includes all partner merchants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutFunnel(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutFunnelResponse> {
            return localVarFp.getCheckoutFunnel(partnerId, fromDate, toDate, merchantIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Groups the partner\'s ledger rows in range by the chosen `dimension` and returns per-group `count`, `volume` (cents), and `sharePercentage` (count-share of total). Used by the Admin UI partner analytics view to render the \"transaction mix\" breakdowns that aren\'t covered by card-mix.  - `transaction-type`: groups by `transaction_type` (PAYMENT / REFUND / VOID / CHARGEBACK) - `payment-method`: groups by `payment_method_type`  Both dimensions count **all ledger rows in range** (not PAYMENT-only) for parity between the two cuts — per FF-2670\'s recommendation. UI filters client-side if it needs a PAYMENT-only view.  `sharePercentage` is **count-share** (group_count / total_count × 100). The `volume` field is returned alongside so the UI can switch to volume-share client-side without a second call.  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list, zero `totalCount`, and zero `totalVolume`. 
         * @summary Transaction breakdown by transaction-type or payment-method
         * @param {string} partnerId Partner identifier
         * @param {GetDashboardBreakdownDimensionEnum} dimension Which dimension to group by. Blank or unknown value returns 400 &#x60;INVALID_DIMENSION&#x60;. 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardBreakdown(partnerId: string, dimension: GetDashboardBreakdownDimensionEnum, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<BreakdownResponse> {
            return localVarFp.getDashboardBreakdown(partnerId, dimension, fromDate, toDate, merchantIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) with sales volume, fee volume, and percentage shares for each category. 
         * @summary Get card mix breakdown by card category
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCardMix(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<CardMixResponse> {
            return localVarFp.getDashboardCardMix(partnerId, fromDate, toDate, merchantIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns time series data for any dashboard metric, suitable for charting. Interval auto-selected by date range span (daily/weekly/monthly). 
         * @summary Get time series data for a specific dashboard metric
         * @param {string} partnerId Partner identifier
         * @param {GetDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardMetricSeries(partnerId: string, metric: GetDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, merchantIds?: string, intervals?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricSeriesResponse> {
            return localVarFp.getDashboardMetricSeries(partnerId, metric, fromDate, toDate, merchantIds, intervals, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregated financial metrics for a partner over a date range.
         * @summary Get aggregated dashboard summary metrics for a partner
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardSummary(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardSummaryResponse> {
            return localVarFp.getDashboardSummary(partnerId, fromDate, toDate, merchantIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Ranks a partner\'s merchants by PAYMENT-type `total_amount` descending over the requested date range, limited to `limit` rows. Each row carries `merchantId`, `merchantName` (null-safe), `transactionCount`, and `salesVolume` (cents). The response envelope also carries the partner-wide `totalSalesVolume` and `currency` so the UI can show \"top N of total\".  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints. Merchant principals are rejected; cross-partner returns 403.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list and a zero `totalSalesVolume`. 
         * @summary Top merchants for a partner ranked by sales volume
         * @param {string} partnerId Partner identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
         * @param {number} [limit] Maximum rows to return. Default 10; clamped to [1, 50]. Values outside the range return 400 &#x60;INVALID_LIMIT_PARAM&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardTopMerchants(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<TopMerchantsResponse> {
            return localVarFp.getDashboardTopMerchants(partnerId, fromDate, toDate, merchantIds, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerDashboardApi - object-oriented interface
 * @export
 * @class PartnerDashboardApi
 * @extends {BaseAPI}
 */
export class PartnerDashboardApi extends BaseAPI {
    /**
     * Returns checkout funnel analytics showing session drop-off and completion metrics.
     * @summary Get checkout funnel analytics for a partner
     * @param {string} partnerId Partner identifier (ULID)
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by. If omitted, includes all partner merchants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerDashboardApi
     */
    public getCheckoutFunnel(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig) {
        return PartnerDashboardApiFp(this.configuration).getCheckoutFunnel(partnerId, fromDate, toDate, merchantIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Groups the partner\'s ledger rows in range by the chosen `dimension` and returns per-group `count`, `volume` (cents), and `sharePercentage` (count-share of total). Used by the Admin UI partner analytics view to render the \"transaction mix\" breakdowns that aren\'t covered by card-mix.  - `transaction-type`: groups by `transaction_type` (PAYMENT / REFUND / VOID / CHARGEBACK) - `payment-method`: groups by `payment_method_type`  Both dimensions count **all ledger rows in range** (not PAYMENT-only) for parity between the two cuts — per FF-2670\'s recommendation. UI filters client-side if it needs a PAYMENT-only view.  `sharePercentage` is **count-share** (group_count / total_count × 100). The `volume` field is returned alongside so the UI can switch to volume-share client-side without a second call.  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list, zero `totalCount`, and zero `totalVolume`. 
     * @summary Transaction breakdown by transaction-type or payment-method
     * @param {string} partnerId Partner identifier
     * @param {GetDashboardBreakdownDimensionEnum} dimension Which dimension to group by. Blank or unknown value returns 400 &#x60;INVALID_DIMENSION&#x60;. 
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerDashboardApi
     */
    public getDashboardBreakdown(partnerId: string, dimension: GetDashboardBreakdownDimensionEnum, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig) {
        return PartnerDashboardApiFp(this.configuration).getDashboardBreakdown(partnerId, dimension, fromDate, toDate, merchantIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) with sales volume, fee volume, and percentage shares for each category. 
     * @summary Get card mix breakdown by card category
     * @param {string} partnerId Partner identifier
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerDashboardApi
     */
    public getDashboardCardMix(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig) {
        return PartnerDashboardApiFp(this.configuration).getDashboardCardMix(partnerId, fromDate, toDate, merchantIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns time series data for any dashboard metric, suitable for charting. Interval auto-selected by date range span (daily/weekly/monthly). 
     * @summary Get time series data for a specific dashboard metric
     * @param {string} partnerId Partner identifier
     * @param {GetDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
     * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerDashboardApi
     */
    public getDashboardMetricSeries(partnerId: string, metric: GetDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, merchantIds?: string, intervals?: number, options?: RawAxiosRequestConfig) {
        return PartnerDashboardApiFp(this.configuration).getDashboardMetricSeries(partnerId, metric, fromDate, toDate, merchantIds, intervals, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregated financial metrics for a partner over a date range.
     * @summary Get aggregated dashboard summary metrics for a partner
     * @param {string} partnerId Partner identifier
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerDashboardApi
     */
    public getDashboardSummary(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, options?: RawAxiosRequestConfig) {
        return PartnerDashboardApiFp(this.configuration).getDashboardSummary(partnerId, fromDate, toDate, merchantIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ranks a partner\'s merchants by PAYMENT-type `total_amount` descending over the requested date range, limited to `limit` rows. Each row carries `merchantId`, `merchantName` (null-safe), `transactionCount`, and `salesVolume` (cents). The response envelope also carries the partner-wide `totalSalesVolume` and `currency` so the UI can show \"top N of total\".  **Authentication:** JWT Bearer token. **Authorization:** Same `ReadDashboardAccessControl` (`partner:read`) gate as the sibling dashboard endpoints. Merchant principals are rejected; cross-partner returns 403.  Single-currency USD; int64-cents amounts. Empty range returns 200 with an empty list and a zero `totalSalesVolume`. 
     * @summary Top merchants for a partner ranked by sales volume
     * @param {string} partnerId Partner identifier
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated list of merchant IDs to filter by.
     * @param {number} [limit] Maximum rows to return. Default 10; clamped to [1, 50]. Values outside the range return 400 &#x60;INVALID_LIMIT_PARAM&#x60;. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerDashboardApi
     */
    public getDashboardTopMerchants(partnerId: string, fromDate: string, toDate: string, merchantIds?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return PartnerDashboardApiFp(this.configuration).getDashboardTopMerchants(partnerId, fromDate, toDate, merchantIds, limit, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetDashboardBreakdownDimensionEnum = {
    TransactionType: 'transaction-type',
    PaymentMethod: 'payment-method'
} as const;
export type GetDashboardBreakdownDimensionEnum = typeof GetDashboardBreakdownDimensionEnum[keyof typeof GetDashboardBreakdownDimensionEnum];
/**
 * @export
 */
export const GetDashboardMetricSeriesMetricEnum = {
    TotalRevenue: 'total-revenue',
    TotalTransactions: 'total-transactions',
    AvgTransaction: 'avg-transaction',
    AcceptancePercentage: 'acceptance-percentage',
    RefundsPercentage: 'refunds-percentage',
    EstimatedSavings: 'estimated-savings',
    FansSaved: 'fans-saved'
} as const;
export type GetDashboardMetricSeriesMetricEnum = typeof GetDashboardMetricSeriesMetricEnum[keyof typeof GetDashboardMetricSeriesMetricEnum];
